import { render, staticRenderFns } from "./CouponsManagerButton.vue?vue&type=template&id=706ae33c&"
import script from "./CouponsManagerButton.vue?vue&type=script&lang=js&"
export * from "./CouponsManagerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports